import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import ImportP4Main from './views/main';
import { HasPermission } from "Core/security"
import { Navigate } from "react-router-dom";

const ImportP4View = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "impp4") && <Route path="list" element={<ImportP4Main />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default ImportP4View